import DuckEntity from './DuckEntity';
import DuckEntityForm from "ducks/DuckEntityForm";
import BigNumber from "bignumber.js";

export const billingConfigs = new DuckEntity('billingConfigs');
export const billingConfigForm = new DuckEntityForm('billingConfigForm', billingConfigs, {
  transformLoad: ({start_year, overdue_threshold, ...rest}) => {
    // Truncate threshold to integer if no decimal, otherwise use 2 decimal places
    let threshold = new BigNumber(overdue_threshold || 0);
    threshold = threshold.toFixed(threshold.isInteger() ? 0 : 2);

    return {
      ...rest,
      overdue_threshold: threshold,
      start_year: start_year || ''
    };
  }
});
